// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"74":"About","88":"potba-configurations","581":"potba-home","764":"potba-parent"}[chunkId] + "." + {"74":"64133be3","88":"6f50dc96","581":"3505d4d9","764":"89f68771"}[chunkId] + ".css";
};